const storageValues = {};

export class LocalStorage<T> {
  private static hasLocalStorage = typeof localStorage !== 'undefined';

  private name: string;

  private get item(): T | null {
    return storageValues[this.name];
  }

  private set item(value: T | null) {
    storageValues[this.name] = value;
  }

  constructor(name: string) {
    this.name = name;
  }

  getItem(): T | null {
    if (!this.item) {
      const itemFromLocalStorage = LocalStorage.hasLocalStorage ? localStorage.getItem(this.name) : null;
      try {
        this.item = itemFromLocalStorage ? JSON.parse(itemFromLocalStorage) : null;
      } catch (e) {
        this.removeItem();
      }
    }
    return this.item;
  }

  setItem(value: T): void {
    if (LocalStorage.hasLocalStorage) {
      localStorage.setItem(this.name, JSON.stringify(value));
    }
    this.item = value;
  }

  removeItem(): void {
    if (LocalStorage.hasLocalStorage) {
      localStorage.removeItem(this.name);
    }
    this.item = null;
  }
}
